import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import curtain from './modules/curtain';
import locale from './modules/locale';
import modal from './modules/modal';
import mobile from './modules/mobile';
import lk from './modules/lk';
import meta from './modules/meta';
import events from './modules/events';
import portal from './modules/portal';
import questionnaries from './modules/questionnaries';

const DEFAULT_API_KEY = "";
const DEFAULT_LOCATIONS = [
    { country: 'Россия' },
    { country: 'Беларусь' }
]
const EMPTY_VALUE = "";

export const store = new Vuex.Store({
    actions: {
        async getCityDadata (_, {
            token = DEFAULT_API_KEY,
            query,
        }) {
            const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";

            const res = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + token
                },
                body: JSON.stringify({
                    locations: DEFAULT_LOCATIONS,
                    query,
                    from_bound: { value: 'city' },
                    to_bound: { value: 'city' }
                })
            })
            const data = await res.json();

            if (!data.suggestions) return [];

            const suggestions = data.suggestions.map(suggestion => ({
                country: suggestion.data?.country || EMPTY_VALUE,
                city: suggestion.data?.city || EMPTY_VALUE,
                district: suggestion.data?.federal_district || EMPTY_VALUE,
                region_with_type: suggestion.data?.region_with_type || EMPTY_VALUE,
                region: suggestion.data?.region || EMPTY_VALUE,
                index: suggestion.data?.postal_code || EMPTY_VALUE
            }));

            return suggestions;
        },
        async getOrganisationDadata (_, {
            token = DEFAULT_API_KEY,
            query,
            country
        }) {
            const isBy = country.toLowerCase() === 'беларусь'

            console.debug('Russia:', !isBy)
            console.debug('Belarus:',isBy)

            const url = `https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party${isBy ? '_by' : ''}`;

            const res = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": "Token " + token
                },
                body: JSON.stringify({ query, count: 20 })
            });

            const data = await res.json();
            console.debug(data);
            if (!data.suggestions) return [];

            console.debug(data.suggestions)

            const suggestions = data.suggestions.map(suggestion => ({
                name:
                    suggestion.data?.fio_ru ||
                    suggestion.data?.full_name_ru ||
                    suggestion.data.name?.short ||
                    suggestion.data.name?.full ||
                    EMPTY_VALUE,
                opf:
                    suggestion.data.opf?.short ||
                    EMPTY_VALUE,
                inn:
                    suggestion.data?.unp ||
                    suggestion.data?.inn ||
                    EMPTY_VALUE,
                kpp:
                    suggestion.data?.kpp ||
                    EMPTY_VALUE,
                address:
                    suggestion.data?.address?.value ||
                    suggestion.data?.address ||
                    EMPTY_VALUE,
                country: 
                    suggestion.data?.address?.data?.country ||
                    EMPTY_VALUE,
                city:
                    suggestion.data?.address?.data?.city ||
                    EMPTY_VALUE,
                index: 
                    suggestion.data?.address?.data?.postal_code ||
                    EMPTY_VALUE,
                region_with_type:
                    suggestion.data?.address?.data?.region_with_type ||
                    EMPTY_VALUE,
                region: 
                    suggestion.data?.address?.data?.region ||
                    EMPTY_VALUE

            }));

            return suggestions;
        }
    },
    modules: {
        curtain,
        locale,
        mobile,
        modal,
        lk,
        meta,
        events,
        portal,
        questionnaries,
    },
    strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js